import React, {Component} from 'react';
import {Layout, Menu, Badge} from 'antd';
import PropTypes from 'prop-types';
import Iconz from './Iconz';
import Head from './Head';
import '../css/Frame.css';

const {Sider, Content} = Layout;
const SubMenu = Menu.SubMenu;

function MenuItem(menu) {
    return (
        <Menu.Item key={menu.key}>
            {
                menu.count ?
                    (
                        <Badge count={menu.count || 0} style={{right: -20}}>
                            <span style={{color: "#fff"}}>{menu.icon ? menu.icon : ''} {menu.text}</span>
                        </Badge>
                    ) :
                    (<span>{menu.icon ? menu.icon : ''} {menu.text}</span>)
            }
        </Menu.Item>
    );
}

class Frame extends Component {
    constructor(props) {
        super(props);
        this.state = {
            menu_key: props.menuSelectKey
        };
    }

    componentWillReceiveProps (nextProps) {
        if (nextProps.menuSelectKey !== this.state.menu_key) {
            this.setState({ menu_key: nextProps.menuSelectKey })
        }
    }

    /**
     * 菜单点击
     * @param e
     */
    handleMenuClick = (e) => {
        const key = e.key, {menuClick, menuSelect} = this.props;
        this.setState({menu_key: key}, () => {
            if (menuSelect) {
                menuSelect(key);
                return false;
            } else if (menuClick) {
                menuClick(key);
                return false;
            }
            let menu = null;
            const menuList = this.props.menuList;
            for (let i = 0; i < menuList.length; i++) {
                if (menu) break;
                const items = menuList[i].items;
                if (items && items.length > 0) {
                    for (let j = 0; j < items.length; j++) {
                        if (items[j].key === key) {
                            menu = items[j];
                            break;
                        }
                    }
                } else if (menuList[i].key === key) {
                    menu = menuList[i];
                    break;
                }
            }
            if (menu && menu.link) {
                this.props.history.replace(menu.link);
            }
        });
    }

    render() {
        let {children, menuList, className, menuSelect, defaultOpenKeys, siderWidth, badge} = this.props,
            {menu_key} = this.state,
            menuObj = {};
        if (menuSelect) {
            menuObj.onSelect = this.handleMenuClick;
        } else {
            menuObj.onClick = this.handleMenuClick;
        }
        siderWidth = siderWidth || '200px'
        return (
            <Layout className={"frame " + (className || '')}>
                <Head notLogin={(
                    <div className="frame-head-logo">
                        <Iconz type="icon-logo_" size={48}/>
                    </div>
                )} background="#3F89C1" height={78} history={this.props.history}/>
                <Content className="frame-content" 
                // style={{overflow: 'hidden'}}
                >
                    <Sider width={siderWidth}>
                        <Menu
                            {...menuObj}
                            className="frame-content-menu"
                            theme="dark"
                            selectedKeys={[menu_key]}
                            defaultOpenKeys={defaultOpenKeys || []}
                            mode="inline"
                        >{
                            menuList.map((menu, i) => {
                                let items = menu.items;
                                if (items && items.length > 0) {
                                    return (
                                        <SubMenu key={"sub" + i} title={<span>{menu.icon ? menu.icon : ''} {menu.text}</span>}>
                                            {items.map((item) => {
                                                return MenuItem(item);
                                            })}
                                        </SubMenu>
                                    );
                                } else {
                                    return MenuItem(menu);
                                }
                            })
                        }
                        </Menu>
                    </Sider>
                    <div className="fc-content" style={{width: 'calc(100% - ' + siderWidth + ')',
                    // overflowX: 'hidden'
                    }}>{children}</div>
                </Content>
                {/*<Footer style={{padding: 0}}>*/}
                {/*<Foote/>*/}
                {/*<ICP bg="#434343"/>*/}
                {/*</Footer>*/}
            </Layout>
        );
    }
}

Frame.propTypes = {
    menuList: PropTypes.array.isRequired, //左侧菜单
    className: PropTypes.string, //class
    menuClick: PropTypes.func,   //菜单点击
    menuSelect: PropTypes.func,   //菜单选择
    menuSelectKey: PropTypes.string,    //菜单选中
    siderWidth: PropTypes.any,    //菜单宽
    defaultOpenKeys: PropTypes.array,   //默认打开菜单
    badge: PropTypes.bool,   //是否微标
}

export default Frame;



// WEBPACK FOOTER //
// ./src/components/Frame.jsx